import React, { useState } from "react";
import { Button, Modal, TableAdv } from "..";
import { mapTableRows } from "../../utils/mapTableRows";

const Placements = ({
  data,
  columnData = [],
  modalTitle = "Selected Files",
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const columns = React.useMemo(() => {
    if (!data || data.length === 0) return [];

    // Get all unique keys from data
    // const allKeys = [...new Set(data.flatMap((item) => Object.keys(item)))];
    const allKeys = [
      ...new Set(
        data
          .filter((item) => item && typeof item === "object")
          .flatMap((item) => Object.keys(item))
      ),
    ];

    // const allKeys = [];

    // Create a map of custom column configurations
    const customColumnMap = columnData.reduce((acc, col) => {
      if (typeof col === "string") {
        // Handle excluded columns
        acc[col] = { show: false };
      } else {
        // Handle custom column configurations
        acc[col.key] = col;
      }
      return acc;
    }, {});

    // Filter and map columns
    const dataColumns = allKeys
      .filter((key) => {
        const customCol = customColumnMap[key];
        return customCol?.show !== false;
      })
      .map((key) => {
        const customCol = customColumnMap[key];
        if (customCol && customCol.key) {
          // Use custom column configuration
          return customCol;
        }
        // Default column configuration
        return {
          key: key,
          label: key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " "),
        };
      });

    // Add additional columns that aren't in the data
    const additionalColumns = columnData.filter(
      (col) => typeof col === "object" && !allKeys.includes(col.key)
    );

    return [...dataColumns, ...additionalColumns];
  }, [data, columnData]);

  // Fix the data mapping to preserve all row properties
  const mappedRows = mapTableRows(data, columns);


  return (
    <div className="flex items-center gap-2">
      <span className="material-symbols-rounded text-[18px]">person_pin</span>
      <div>
        <Button
          title={data.length <= 0 ? "--" : data.length}
          size="sm"
          disabled={data.length <= 0}
          // comment this to prevent click and opening the placement modal
          onClick={() => setIsOpenModal(true)}
          className="self-center !py-0 !max-h-7"
        />
      </div>

      <Modal
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        // title="Selected Files"
        title={modalTitle}
        width="max-w-6xl"
        button
      >
        <TableAdv tableId={`clients_clientswithactiveplacements_placements`} rows={mappedRows} columns={columns} hideToolBar />
      </Modal>
    </div>
  );
};

export default Placements;
